import styled from 'styled-components';
import { TProps } from '../types/TProps';

export const Wrapper = styled.div<TProps>`
  background: #ffffff;
  box-shadow: 0 10px 15px rgba(0, 0, 0, 0.05);
  border-radius: 5px;
  position: relative;
  padding: 30px;
  text-align: left;

  ${(props) =>
    props.overflow !== 'visible' &&
    `
    overflow-x: hidden;
    overflow-y: auto;
    max-height: 90vh;
  `};

  display: flex;
  flex-direction: column;
  gap: 30px;

  ${(props) => props.width && `width: ${props.width}px`};

  .close-icon {
    position: absolute;
    top: 20px;
    right: 20px;
    cursor: pointer;
    path {
      fill: #858dbd;
    }
    :hover {
      path {
        fill: #40608f;
      }
    }
  }
`;
